import {
    DISPLAYAREAS_LOADING, DISPLAYAREAS_BY_ID_LOADING, DISPLAYAREAS_BY_ID_AND_TYPE_LOADING,
    GET_DISPLAYAREAS_DATA_SUCCESS,
    GET_DISPLAYAREAS_DATA_ERROR, RESET_DISPLAYAREAS
} from "../actions/actionDisplayAreas";

import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "DisplayAreaNos";

const initialState = {
    displayAreaID: 0,
    displayAreas: [],
    displayArea: loadState(sessionKey, {}),
    loading: false,
    displayAreasError: '',
    isDisplay: false
};

function reducerDisplayAreas(state = initialState, action) {
    switch (action.type) {
        case DISPLAYAREAS_LOADING:
        case DISPLAYAREAS_BY_ID_LOADING:
        case DISPLAYAREAS_BY_ID_AND_TYPE_LOADING: {
            return {
                ...state,
                displayAreas: [],
                loading: true,
                displayAreasError: ''
            };
        }

        case GET_DISPLAYAREAS_DATA_SUCCESS: {

            let newObj = {};

            if (action.id !== null && action.id !== undefined) {
                let newDisplayAreas = JSON.parse(JSON.stringify(action.payload));
                newObj = { ...newDisplayAreas.filter(x => x.DisplayAreaNo == action.id)[0] };
                saveState(sessionKey, newObj);
            }

            return {
                ...state,
                loading: false,
                displayAreas: action.payload,
                displayArea: newObj,
                isDisplay: action.isDisplay,
                displayAreasError: ''
            };
        }

        case GET_DISPLAYAREAS_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                isDisplay: false,
                displayAreas: action.payload,
                displayAreasError: action.error
            }
        }
        case RESET_DISPLAYAREAS: {

            saveState(sessionKey, {});

            return {
                ...state,
                loading: false,
                isDisplay: false,
                displayArea: {},
                displayAreas: [],
                displayAreasError: ''
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerDisplayAreas;